import { Controller, useFormContext } from 'react-hook-form';
import { DynamicFieldItemData } from './dynamic-control-types';
import { useEffect } from 'react';
import BaseInput from 'components/common/BaseInput';

export const DynamicControl = ({
    inputType,
    fieldName,
    label,
    defaultValue,
    options = [],
    config = {},
}: DynamicFieldItemData) => {
    // const validationRules = {
    //     minLength: config.minLength,
    //     maxLength: config.maxLength,
    // };
    const { register, control, setValue } = useFormContext();

    useEffect(() => {
        if (inputType === 'toggle') {
            setValue(fieldName, convertToBoolean(defaultValue));
        } else {
            setValue(fieldName, defaultValue);
        }
    }, [defaultValue, fieldName, setValue, inputType]);

    const convertToBoolean = (value: string | number | boolean) => {
        if (typeof value === 'boolean') {
            return value;
        }
        if (typeof value === 'string') {
            return value.toLowerCase() === 'true';
        }
        return Boolean(value);
    };

    switch (inputType) {
        case 'text':
            return (
                <div>
                    <input
                        type="text"
                        {...register(fieldName, {
                            // ...config,
                        })}
                        name={fieldName}
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '3px',
                            padding: '5px',
                        }}
                    />
                </div>
            );
        case 'textarea':
            return (
                <div
                    style={{
                        padding: '10px',
                        borderRadius: '5px',
                    }}
                >
                    <input
                        type="text"
                        {...register(
                            fieldName
                            //   config,
                        )}
                        name={fieldName}
                        // defaultValue={defaultValue}
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '3px',
                            padding: '5px',
                        }}
                    />
                </div>
            );
        case 'select': {
            return (
                <select
                    {...register(
                        fieldName
                        // config
                    )}
                    name={fieldName}
                    id={fieldName}
                >
                    {options.map((o, index) => (
                        <option key={index} value={o.value}>
                            {o.label}
                        </option>
                    ))}
                </select>
            );
        }
        case 'number':
            return (
                <div style={{ padding: '10px', borderRadius: '5px' }}>
                    <input
                        type="number"
                        {...register(
                            fieldName
                            // config
                        )}
                        name={fieldName}
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '3px',
                            padding: '5px',
                        }}
                    />
                </div>
            );
        case 'dropdown':
            return (
                <div style={{ padding: '10px', borderRadius: '5px' }}>
                    <select
                        {...register(
                            fieldName
                            // config
                        )}
                        name={fieldName}
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '3px',
                            padding: '5px',
                        }}
                    >
                        {options?.map((o, index: number) => (
                            <option key={index} value={o.value}>
                                {o.label}
                            </option>
                        ))}
                    </select>
                </div>
            );
        case 'toggle':
            return (
                <div style={{ padding: '10px', borderRadius: '5px', marginLeft: 'auto' }}>
                    <Controller
                        name={fieldName}
                        control={control}
                        defaultValue={convertToBoolean(defaultValue)}
                        render={({ field }) => (
                            <input
                                type="checkbox"
                                {...field}
                                checked={field.value}
                                onChange={(e) => setValue(fieldName, e.target.checked)}
                                name={fieldName}
                                style={{
                                    marginLeft: 'auto',
                                    width: '50px',
                                }}
                            />
                        )}
                    />
                </div>
            );
        case 'date':
            return (
                <div style={{ borderRadius: '5px', width: '100%' }}>
                    <input
                        type="date"
                        {...register(fieldName, {
                            //  ...validationRules,
                        })}
                        name={fieldName}
                        // defaultValue={defaultValue}
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '3px',
                            padding: '5px',
                        }}
                    />
                </div>
            );
        default:
            return <BaseInput type="text" defaultValue={defaultValue} />;
    }
};
